





















































import Vue from "vue";
import { Component, Watch, Prop } from "vue-property-decorator";
import { Action } from "vuex-class";
import { AppConstants as _app } from "@/shared/app.constants";
import AuthService from "@/services/auth.service";
import { http } from "@/shared/https";

import "@/styles/iucn/filter.css";
import "@/styles/iucn/main-content.css";
const auth = new AuthService();
@Component({
  components: {},
})
export default class InternalReviewListComponent extends Vue {
  @Action("create", { namespace: "assessmentForm" }) createReview: any;
  @Action("setReviewId", { namespace: "assessmentForm" }) setReview: any;
  reviewAllowedStatus = _app.internalReviewAllowedStatus;
  readonlyStatus = [
    _app.reviewStatus.COI_Rejected,
    _app.reviewStatus.Internal_Submitted,
  ];
  inProgressStatus = [_app.reviewStatus.Internal_In_Progress];
  reviews: Array<any> = [];
  internalReview: any = {};
  appSummary: any = {};
  options: any = {};
  @Prop() items: any;
  @Prop() entity: any;

  mounted() {
    auth.getUser().then((user: any) => {
      if (user && user.profile) {
        this.options = {
          userInfo: {
            userName: user.profile.given_name,
            updatedUserDd: "",
            updatedUserBa: "",
          },
          modifiedAt: this.formattedDate(),
        };
      }
    });
  }

  viewReview(item: any)
  {
    if (item !== null) {
        let routeData = this.$router.push({
          name: "readOnlyInternalReviewSummary",
          params: { applicationId: item.ApplicationId,  entity: this.entity }
        });
      }
  }
  // listProposal() {
  //   return this.$services.reviewinternal.listProposal();
  // }

  listReviews(e) {
    var self = this;
    http.get(`/api/ReviewInternal?${e}`).then((resp: any) => {
      if (resp.data && resp.data.Items) {
        self.reviews = resp.data.Items;
      }
    });
  }

  /** Start review of the application */
  startReview(item) {
    this.$router.push({
      name: "internalReviewSummary",
      params: { applicationId: item.ApplicationId, entity: this.entity },
    });

    // var self = this;

    // if (item.InternalReviewId) {
    //   this.setReview(item.InternalReviewId);
    //   this.$router.push({
    //     name: "internalReviewSummary",
    //     params: { reviewId: item.InternalReviewId }
    //   });
    // } else {
    //   self
    //     .createReview({ ApplicationId: item.ApplicationId })
    //     .then((data: any) => {
    //       if (data && data.InternalReviewId) {
    //         this.setReview(data.InternalReviewId);
    //         this.$router.push({
    //           name: "internalReviewSummary",
    //           params: { reviewId: data.InternalReviewId }
    //         });
    //       }
    //     });
    // }
  }
  formattedDate() {
    const date = new Date();
    return this.$services.format.formatUTC(date);
  }
  downloadPdf(item) {
    this.appSummary = item;
    let temp: any = {};
    this.$services.reviewinternal
      .reviewSummary(item.ApplicationId, this.entity)
      .then((resp) => {
        if (resp && resp.Result === "ERROR") {
          // not found case
        } else if (resp) {
          temp.sections = resp.sections;
          temp["duedeligenceTemp"] = {};
          temp["budgetAsessmentTemp"] = {};
          temp["ddData"] = {};
          temp["budgetData"] = {};
          if (resp["budgetReview"] != null) {
            this.options.userInfo.updatedUserBa = resp["budgetReview"]["UserName"];
            resp["budgetReview"].template.forEach((element) => {
              temp["budgetAsessmentTemp"] = element.Value.properties.budget;
            });
            temp["budgetData"] = resp["budgetReview"]["data"];
          }
          if (resp["ddReview"] != null) {
            this.options.userInfo.updatedUserDd = resp["ddReview"]["UserName"];
            resp["ddReview"].template.forEach((element) => {
              temp["duedeligenceTemp"] =
                element.Value.properties.dueDiligence.properties;
            });
            temp["ddData"] = resp["ddReview"]["data"];
          }
          this.$services.AsessmentPrint.print(
            this.options,
            this.appSummary,
            temp
          );
        }
      });
  }
}
